export const ERROR_CLASS = 'error';
export const INVALID_CLASS = 'invalid';
export const SUCCESS_CLASS = 'success';

export default class AjaxForm {
    constructor(element, gtm) {
        this.$element = $(element);
        this.gtm = gtm || {trackEvent: function() { }};
        this.url = this.$element.data('url');
        this.csrfToken = this.$element.find('[name="_csrf"]').val();
        this.contentType = this.$element.data('ajaxContentType');
        this.refreshAfterSuccess = this.$element.data('refreshAfterSuccess');
        this.redirectAfterSuccess = this.$element.data('redirectAfterSuccess');
        this.redirectAfterSuccessUrl = this.$element.data('redirectAfterSuccessUrl');
        this.redirectAfterError = this.$element.data('redirectAfterError');
        this.$errorElements = $(this.$element.data('ajaxErrorElements'));
        this.$invalidableElements = $(this.$element.data('ajaxInvalidableElements'));
        this.gtmSuccess = this.$element.data('gtm-success');
        this.gtmFail = this.$element.data('gtm-fail');
        this.$loaderElement = this.$element.find(this.$element.data('loaderElement'));
        this.tooltipSuccess =  this.$element.data('tooltip-success');
        this.tooltipFail =  this.$element.data('tooltip-fail');
        this.recaptchaRender = this.$element.data('recaptchaRender');
        this.recaptchaElementId = this.$element.data('recaptchaElementId');
        this.recaptchaSiteKey = $('#' + this.recaptchaElementId).data('sitekey');
        this.avoidRefresh = this.$element.data('avoidRefresh');
    }

    static redirectTo(newUrl) {
        // NOTE: bad hack to handle registration confirmation
        $(window).on('hashchange', () => {
            window.location.reload();
        });
        window.location.href = newUrl;
    }

    static redirectToWithoutRefresh(newUrl) {
        window.location.href = newUrl;
    }

    static refreshPage() {
        // refresh the current page removing the hash
        // and remove the previous one from history
        window.location.replace(location.href.split('#')[0]);
    }

    _recaptchaHandler() {
        this._executeXhr();
    }

    _recaptchaHandlerError() {
        console.log('recaptcha error');
        return false;
    }

    _recaptchaHandlerExpired() {
        console.log('recaptcha expired');
        return false;
    }

    _executeXhr(extraParam) {
        const url = this.url + ((extraParam) ? extraParam : '');

        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        if (this.csrfToken) {
            this.headers['X-CSRF-Token'] = this.csrfToken;
        }

        if (this.contentType) {
            this.headers['Content-Type'] = this.contentType;
        }

        const options = {
            method: 'POST',
            data: this.getData(),
            processData: false,
            headers: this.headers,
            beforeSend: this.showLoader.bind(this),
            statusCode: {
                403: () => {
                    window.location.reload();
                }
            }
        };

        $.ajax(url, options)
            .done(this.xhrSuccess.bind(this))
            .fail(this.xhrFail.bind(this))
            .always(this.xhrAlways.bind(this));
    }

    submit(event) {
        this.validate(event);
        if (event.isDefaultPrevented()) {
            return;
        }
        event.preventDefault();

        if (this.recaptchaRender) {
            const recaptchaId = $(`#${this.recaptchaElementId}`).data('recaptchaId');
            if(window.grecaptcha.getResponse(recaptchaId)) {
                this._executeXhr();
            } else {
                // TODO: KO
            }
            return;
        }

        const extraParam = $(event.currentTarget).data('extraparam');
        this._executeXhr(extraParam);
    }

    showLoader() {
        this.$loaderElement.get(0) && this.$loaderElement.trigger('loader:show');
    }

    hideLoader() {
        this.$loaderElement.get(0) && this.$loaderElement.trigger('loader:hide');
    }

    xhrAlways() {
        this.hideLoader();
    }

    xhrSuccess(response) {
        // gtm events...
        if(this.gtmSuccess) {
            this.gtm.trackEvent(this.gtmSuccess, '');
        }

        if(this.tooltipSuccess) {
            $(this.tooltipSuccess).removeClass('hidden');
            $(this.tooltipFail).addClass('hidden');
        }

        if (this.refreshAfterSuccess) {
            AjaxForm.refreshPage();
        }
        if (this.redirectAfterSuccess) {
            if (this.avoidRefresh) {
                AjaxForm.redirectToWithoutRefresh(this.redirectAfterSuccess);
            } else {
                AjaxForm.redirectTo(this.redirectAfterSuccess);
            }
        }
        if (this.redirectAfterSuccessUrl) {
            const redirectUrl = response.redirectUrl;
            if (this.avoidRefresh) {
                AjaxForm.redirectToWithoutRefresh(redirectUrl);
            } else {
                AjaxForm.redirectTo(redirectUrl);
            }
        }
        if (response.ok) {
            this.$element.parent().addClass(SUCCESS_CLASS).removeClass(ERROR_CLASS);
            this.$element[0].reset();
            this.$element.trigger('ajaxform.success');
        } else {
            this.$element.parent().addClass(ERROR_CLASS).removeClass(SUCCESS_CLASS);
        }
    }

    xhrFail() {
        // gtm events...
        if(this.gtmFail) {
            this.gtm.trackEvent(this.gtmFail, '');
        }

        if(this.tooltipFail) {
            $(this.tooltipSuccess).addClass('hidden');
            $(this.tooltipFail).removeClass('hidden');
        }

        if (this.redirectAfterError) {
            if (this.avoidRefresh) {
                AjaxForm.redirectToWithoutRefresh(this.redirectAfterError);
            } else {
                AjaxForm.redirectTo(this.redirectAfterError);
            }
        }

        // TODO: consider status codes
        this.$element.addClass(ERROR_CLASS);
        this.$element.parent().addClass(ERROR_CLASS).removeClass(SUCCESS_CLASS);
        if (this.$invalidableElements) {
            this.$invalidableElements.addClass(INVALID_CLASS);
        }
        if (this.$errorElements) {
            this.$errorElements.show();
        }
    }

    resetInvalid() {
        this.$invalidableElements.removeClass(INVALID_CLASS);
    }

    validate(event) {
        this.resetInvalid();
        this.$element.find('input, select, textarea').each((index, field) => {
            const validator = $(field).data('validator');

            if (typeof validator !== 'undefined' && typeof(validator['validateForm']) === 'function') {
                validator.validateForm(event);
            }
        });
    }

    getData() {
        const data = this.$element.serializeArray(),
            object = {};

        for (let i = 0; i < data.length; i++) {
            object[data[i].name] = data[i].value;
        }

        if (this.contentType === 'application/x-www-form-urlencoded') {
            return this.$element.serialize();
        }

        return JSON.stringify(object);
    }

    renderRecaptcha() {
        if ($(`#${this.recaptchaElementId}`).data('recaptchaId') !== undefined) {
            return;
        }
        const recaptchaId = window.grecaptcha.render(this.recaptchaElementId, {
            sitekey: this.recaptchaSiteKey,
            'error-callback': this._recaptchaHandlerError.bind(this),
            'expired-callback': this._recaptchaHandlerExpired.bind(this)
        });
        $(`#${this.recaptchaElementId}`).data('recaptchaId', recaptchaId);
    }

    // resetRecaptcha() {
    //     const recaptchaId = $(`#${this.recaptchaElementId}`).data('recaptchaId');
    //     window.grecaptcha.reset(recaptchaId);
    // }

    init() {
        if (this.recaptchaRender) {
            $(document).on('recaptcha:ready', this.renderRecaptcha.bind(this));
        }

        this.$element
            .off('submit.ajaxform', '', $.proxy(this, 'submit'))
            .on('submit.ajaxform', $.proxy(this, 'submit'));

        this.$element.find('.submit-link')
            .off('click.ajaxform', '', $.proxy(this, 'submit'))
            .on('click.ajaxform', $.proxy(this, 'submit'));
    }
}


module.exports = AjaxForm;
